import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { motion } from "framer-motion";
import { Button, Col, Row } from "react-bootstrap";
import { CloudUpload } from "@mui/icons-material";
import toast from "react-hot-toast";

import {
    createNewSlider,
    updateSlider,
    getAdminSlider
} from "../../../../redux/actions/sliderActions";

import {
    clearSliderUpdated,
    clearError,
    clearSliderCreated
} from "../../../../redux/slices/sliderSlice";


const SliderForm = () => {

    const { id } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [preview, setPreview] = useState(null);

    const {
        isSliderCreated,
        isSliderUpdated,
        slider,
        loading,
        error
    } = useSelector(state => state.sliderState);


    const [initialValues, setInitialValues] = useState({
        name: "",
        link: "",
        image: null,
        sortOrder: 0,
        isActive: true,
    });


    const validationSchema = Yup.object({

        name: Yup.string()
            .required("Banner title is required"),

        link: Yup.string()
            .required("Redirect link is required"),

        image:
            id && preview
                ? Yup.mixed().nullable()
                : Yup.mixed().required("Image is required"),
    });



    useEffect(() => {

        if (id) {
            dispatch(getAdminSlider(id));
        }

    }, [id, dispatch]);



    useEffect(() => {

        if (id && slider?._id === id) {

            setInitialValues({

                name: slider.name || "",

                link: slider.link || "",

                image: slider.image || null,

                sortOrder: slider.sortOrder || 0,

                isActive: slider.isActive ?? true,

            });


            if (slider.image) {
                setPreview(slider.image);
            }

        }

    }, [slider, id]);




    useEffect(() => {


        if (isSliderCreated) {

            dispatch(clearSliderCreated());

            toast.success("Banner added successfully");

            navigatePage();
        }


        if (isSliderUpdated) {

            dispatch(clearSliderUpdated());

            toast.success("Banner updated successfully");

            navigatePage();

        }



        if (error) {

            dispatch(clearError());

            toast.error(error);

        }


    }, [
        isSliderCreated,
        isSliderUpdated,
        error,
        dispatch
    ]);




    const navigatePage = () => {

        setTimeout(() => {

            navigate("/admin/slider");

        }, 1500);

    };




    const clearForm = () => {

        setInitialValues({

            name: "",

            link: "",

            image: null,

            sortOrder: 0,

            isActive: true,

        });


        setPreview(null);

    };





    const handleImageChange = (e, setFieldValue) => {

        const file = e.target.files[0];


        if (!file) return;



        if (!file.type.startsWith("image/")) {

            toast.error("Only image files allowed");

            return;
        }



        if (file.size > 5 * 1024 * 1024) {

            toast.error("Maximum image size is 5MB");

            return;
        }



        setPreview(URL.createObjectURL(file));

        setFieldValue("image", file);

    };





    const handleSubmit = async(values) => {


        const formData = new FormData();


        formData.append("name", values.name);

        formData.append("link", values.link);

        formData.append("sortOrder", values.sortOrder);

        formData.append("isActive", values.isActive);



        if(values.image instanceof File){

            formData.append("image", values.image);

        }



        if(id){

            dispatch(updateSlider(id, formData));

        }else{

            dispatch(createNewSlider(formData));

        }

    };





    return (

        <motion.div
            className="container py-4"
            initial={{opacity:0,y:40}}
            animate={{opacity:1,y:0}}
        >


            <h4 className="fw-bold text-center mb-4">

                {id ? "Edit Home Banner" : "Add Home Banner"}

            </h4>




            <Formik

                enableReinitialize

                initialValues={initialValues}

                validationSchema={validationSchema}

                onSubmit={handleSubmit}

            >


            {({setFieldValue, values}) => (


            <Form>


            <Row className="g-4">



            <Col md={6}>

                <label className="form-label">
                    Title *
                </label>


                <Field

                    name="name"

                    className="form-control"

                    placeholder="e.g. Summer Sale"

                />


                <ErrorMessage

                    name="name"

                    component="div"

                    className="text-danger small"

                />

            </Col>




            <Col md={6}>


                <label className="form-label">

                    Redirect Link *

                </label>


                <Field

                    name="link"

                    className="form-control"

                    placeholder="https://example.com"

                />


                <ErrorMessage

                    name="link"

                    component="div"

                    className="text-danger small"

                />


            </Col>





            <Col md={12}>


                <label className="form-label">

                    Banner Image *

                </label>



                <input

                    type="file"

                    accept="image/*"

                    className="form-control"

                    onChange={(e)=>
                        handleImageChange(e,setFieldValue)
                    }

                />



                <ErrorMessage

                    name="image"

                    component="div"

                    className="text-danger small"

                />



                {preview &&

                <motion.img

                    src={preview}

                    alt={values.name}

                    className="rounded shadow mt-3"

                    style={{

                        width:"100%",

                        maxHeight:"300px",

                        objectFit:"cover"

                    }}

                />

                }



            </Col>






            <Col md={6}>


            <label className="form-label">

                Sort Order

            </label>


            <Field

                type="number"

                name="sortOrder"

                className="form-control"

            />


            </Col>





            <Col md={6}>


            <label className="form-label fw-semibold">

                Status

            </label>


            <div className="form-check form-switch">


            <Field

                type="checkbox"

                name="isActive"

                className="form-check-input"

            />


            <span className="ms-2">

                {values.isActive ? "Active":"Inactive"}

            </span>


            </div>


            </Col>





            <Col md={12} className="text-center">


            <Button

                type="submit"

                variant="success"

                disabled={loading}

                className="px-5"

            >


            {
                loading
                ?
                "Saving..."
                :
                <>
                <CloudUpload className="me-2"/>
                {id ? "Update":"Save"}
                </>
            }


            </Button>


            </Col>




            </Row>


            </Form>


            )}

            </Formik>


        </motion.div>

    );

};


export default SliderForm;